import React from 'react';
import { Select, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { UrlRule } from '../types';

const { Option } = Select;

interface UrlRuleFormProps {
  urlRule: UrlRule;
  onUpdate: (id: string, field: keyof UrlRule, value: any) => void;
  onRemove: (id: string) => void;
}

const UrlRuleForm: React.FC<UrlRuleFormProps> = ({ urlRule, onUpdate, onRemove }) => {
  const hasTypeError = !urlRule.type;
  const hasOperatorError = !urlRule.operator;
  const hasValuesError =
    !urlRule.values ||
    urlRule.values.length === 0 ||
    urlRule.values.some((val) => !val || val.trim() === '');

  // Dynamic placeholder based on URL type
  const getPlaceholder = () => {
    switch (urlRule.type) {
      case 'host':
        return 'e.g. example.com';
      case 'path':
        return 'e.g. /api/users';
      case 'sch':
        return 'e.g. https';
      default:
        return 'Enter value';
    }
  };

  return (
    <div key={urlRule.id}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12, marginLeft: 46 }}>
        <Select
          value={urlRule.type}
          onChange={(value) => onUpdate(urlRule.id, 'type', value)}
          style={{
            width: 120,
            marginRight: 8,
          }}
          status={hasTypeError ? 'error' : undefined}
          placeholder="Select URL component"
          data-test-id="url-rule-type-select"
        >
          <Option value="host">Host</Option>
          <Option value="path">Path</Option>
          <Option value="sch">Scheme</Option>
        </Select>
        <Select
          value={urlRule.operator}
          onChange={(value) => onUpdate(urlRule.id, 'operator', value)}
          style={{
            width: 120,
            marginRight: 8,
          }}
          status={hasOperatorError ? 'error' : undefined}
          placeholder="Choose condition"
          data-test-id="url-rule-operator-select"
        >
          <Option value="starts with">Starts with</Option>
          <Option value="ends with">Ends with</Option>
          <Option value="equals">Equals</Option>
          <Option value="contains">Contains</Option>
        </Select>
        <div style={{ display: 'flex', minWidth: 200, maxWidth: 500, marginRight: 8 }}>
          <Select
            mode="tags"
            style={{
              width: '100%',
            }}
            status={hasValuesError ? 'error' : undefined}
            placeholder={getPlaceholder()}
            value={urlRule.values}
            onChange={(values) => onUpdate(urlRule.id, 'values', values)}
            tokenSeparators={[',']}
            maxTagCount="responsive"
            data-test-id="url-rule-values-select"
          />
        </div>
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => onRemove(urlRule.id)}
          size="small"
          style={{ marginLeft: 8 }}
        />
      </div>
    </div>
  );
};

export default UrlRuleForm;
